export const getImportModalComponents = (components) => {
  const importComponents = [];
  components.forEach((component) => {
    switch (component.type) {
      case 'forms':
        importComponents.push('Forms and templates');
        importComponents.push('Automated workflows and rules');
        break;
      case 'boards':
        importComponents.push('Custom boards and views');
        break;
      case 'customFields':
        importComponents.push('Custom fields');
        break;
      default:
        break;
    }
  });
  return importComponents;
};
